<div class="row mb-3" [formGroup]="group()">
  <div class="col-12">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2 class="mb-0">Person Responsible For Payment</h2>
      <button mat-flat-button color="primary" (click)="emitSameAsPatient()">Same As Patient</button>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <mat-form-field appearance="fill" color="primary" class="w-100">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="billingContactFirstName" type="text"/>
        </mat-form-field>
        <mat-form-field appearance="fill" color="primary" class="w-100">
          <mat-label>Surname</mat-label>
          <input matInput formControlName="billingContactSurname" type="text"/>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <mat-form-field appearance="fill" color="primary" class="w-100">
          <mat-label>Identity Number</mat-label>
          <input matInput formControlName="billingContactIdentityNumber" type="text"/>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field appearance="fill" color="primary" class="w-100">
          <mat-label>Confirm Identity Number</mat-label>
          <input matInput formControlName="billingContactIdentityNumberConfirmation" type="text"/>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <h4 class="mb-3">Contact Details</h4>
      @for (group of contactNumbers.controls; track group; let i = $index) {
        <app-patient-contact-form
          [controlFormGroup]="group"
          [index]="i"
          (delete)="removeContactNumber($event)"
          [deleteEnabled]="contactNumbers.controls.length > 1">
        </app-patient-contact-form>
      }
      <div class="row">
        <div class="col-12 col-md-6">
          <button mat-button color="primary" class="w-100" (click)="addContactNumber()">Add Phone Number</button>
        </div>
      </div>
    </div>
    <mat-divider inset class="w-50"></mat-divider>
    <div class="row">
      <div class="col-12">
        <h4 class="mb-3">Email Address Details</h4>
        @for (group of emailAddresses.controls; track group; let i = $index) {
          <app-patient-email-form
            [controlFormGroup]="group"
            [index]="i"
            (delete)="removeEmailAddress($event)"
            [deleteEnabled]="emailAddresses.controls.length > 1">
          </app-patient-email-form>
        }
        <div class="row">
          <div class="col-12 col-md-6">
            <button mat-button color="primary" class="w-100" (click)="addEmailAddress()">Add Email Address</button>
          </div>
        </div>
      </div>
    </div>
    <mat-divider inset class="w-50"></mat-divider>
    <div class="row">
      <div class="col-12">
        <h4 class="mb-3">Address Details</h4>
        @for (group of addressDetails.controls; track group; let i = $index) {
          <app-patient-address-form
            [controlFormGroup]="group"
            [index]="i"
            (delete)="removeAddress($event)"
            [deleteEnabled]="addressDetails.controls.length > 1">
          </app-patient-address-form>
        }
        <div class="row">
          <div class="col-12 col-md-6">
            <button mat-button color="primary" class="w-100" (click)="addAddress()">Add Address</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
